module.exports = __webpack_public_path__ + "static/media/ACM-Parivartan-dark.587e8980.jpeg";